/* ==========================================================================
   Feel · Search Drawer — Interactive Logic
   Source: _mockups/04_SEARCH_DRAWER_PIECES/search-drawer-script.html
   Data: window.SD_CATALOG injected by snippets/feel-search-drawer.liquid
   Cart: uses window.cartDrawer (exposed by feel-cart-drawer.js)
   ========================================================================== */

(function () {
  'use strict';

  /* Translated strings (window.FA_SEARCH_STRINGS, escaped via | t — no re-esc). */
  var FA = window.FA_SEARCH_STRINGS || {};
  var QUICK_SHOP = FA.quick_shop || 'Quick shop';

  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const drawer   = document.querySelector('[data-sd-drawer]');
    const backdrop = document.querySelector('[data-sd-backdrop]');
    const input    = document.querySelector('[data-sd-input]');
    const clearBtn = document.querySelector('[data-sd-clear]');
    const closeBtn = document.querySelector('[data-sd-close]');
    const tabs     = document.querySelectorAll('[data-sd-tab]');
    const panels   = document.querySelectorAll('[data-sd-panel]');
    const pre      = document.querySelector('[data-sd-pre]');
    const results  = document.querySelector('[data-sd-results]');
    const empty    = document.querySelector('[data-sd-empty]');
    const recentSection = document.querySelector('[data-sd-recent-section]');
    const recentList    = document.querySelector('[data-sd-recent-list]');
    const recentClear   = document.querySelector('[data-sd-recent-clear]');
    const loadingEl     = document.querySelector('[data-sd-loading]');
    const suggestEl     = document.querySelector('[data-sd-suggest]');
    const shortcutHint  = document.querySelector('[data-sd-shortcut]');

    if (!drawer || !input) return; // guard: snippet not on page

    // ===== CATALOG from Liquid (window.SD_CATALOG injected by snippet) =====
    const catalog  = window.SD_CATALOG || { products: [], articles: [], pages: [] };
    const PRODUCTS = catalog.products;
    const ARTICLES = catalog.articles;
    const PAGES    = catalog.pages;

    // Visual tone gradients per product handle
    const SD_TONES = {
      'meno-balance':            ['#fbe1e8', '#fdf3f5'],
      'magnesium-balance':       ['#fcf2cd', '#fef9e7'],
      'kollagen-elixier':        ['#fdd9c8', '#fef0e7'],
      'schlaf-essenz':           ['#e0d4f0', '#f0e4f8'],
      'darm-balance-probiotikum':['#d9e8d6', '#e8f0e2'],
      'detox-essenz':            ['#e8e0d4', '#f0eadf'],
      'nad-jugendelixier':       ['#e0d4e8', '#ede0f0'],
      'electrolyt-essenz':       ['#d4e4ea', '#e2eef3']
    };

    // ===== STATE =====
    let activeTab     = 'products';
    let currentQuery  = '';
    let debounceTimer = null;

    // ===== OPEN / CLOSE =====
    function openDrawer() {
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert'); // a11y: focusable again when open
      backdrop.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      document.body.classList.add('feel-drawer-open'); // hides floating chat launcher (overlaps drawer UI)
      renderRecent();
      setTimeout(() => input.focus(), 300);
    }

    function closeDrawer() {
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', ''); // a11y: remove closed drawer from tab order (aria-hidden-focus)
      backdrop.removeAttribute('data-open');
      document.body.style.overflow = '';
      document.body.classList.remove('feel-drawer-open');
    }

    // Wire ALL [data-search-open] triggers (desktop + mobile)
    document.querySelectorAll('[data-search-open]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        openDrawer();
      });
    });

    closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') closeDrawer();
    });

    // ===== TABS =====
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        activeTab = tab.dataset.sdTab;
        tabs.forEach(t => t.removeAttribute('data-active'));
        tab.setAttribute('data-active', 'true');
        panels.forEach(p => p.removeAttribute('data-active'));
        const panel = document.querySelector(`[data-sd-panel="${activeTab}"]`);
        if (panel) panel.setAttribute('data-active', 'true');
        kbResetIndex();
      });
    });

    // ===== SEARCH INPUT =====
    input.addEventListener('input', (e) => {
      const q = e.target.value.trim();
      clearBtn.setAttribute('data-show', q.length > 0 ? 'true' : 'false');
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => doSearch(q), 200);
    });

    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.removeAttribute('data-show');
      doSearch('');
      input.focus();
    });

    // Chip click → set query
    document.querySelectorAll('[data-sd-chip]').forEach(chip => {
      chip.addEventListener('click', () => {
        const q = chip.dataset.sdChip;
        input.value = q;
        clearBtn.setAttribute('data-show', 'true');
        doSearch(q);
      });
    });

    // ===== SEARCH LOGIC =====
    function doSearch(q) {
      currentQuery = q.toLowerCase();

      if (q.length > 0) {
        loadingEl.setAttribute('data-show', 'true');
        pre.style.display     = 'none';
        results.style.display = 'none';
        empty.style.display   = 'none';
        suggestEl.style.display = 'none';
      }

      setTimeout(() => {
        loadingEl.removeAttribute('data-show');

        if (!q) {
          pre.style.display       = '';
          results.style.display   = 'none';
          empty.style.display     = 'none';
          suggestEl.style.display = 'none';
          document.querySelectorAll('[data-sd-count]').forEach(c => c.textContent = '');
          kbResetIndex();
          return;
        }

        const productHits = PRODUCTS.filter(p => matches(p, q));
        const articleHits = ARTICLES.filter(a => matches(a, q));
        const pageHits    = PAGES.filter(pg => matches(pg, q));
        const totalHits   = productHits.length + articleHits.length + pageHits.length;

        if (totalHits === 0) {
          pre.style.display     = 'none';
          results.style.display = 'none';
          empty.style.display   = '';
          document.querySelectorAll('[data-sd-count]').forEach(c => c.textContent = '0');
          renderSuggest(q, empty);
          saveRecent(q);
          kbResetIndex();
          return;
        }

        pre.style.display     = 'none';
        results.style.display = '';
        empty.style.display   = 'none';

        document.querySelector('[data-sd-count="products"]').textContent = productHits.length;
        document.querySelector('[data-sd-count="articles"]').textContent = articleHits.length;
        document.querySelector('[data-sd-count="pages"]').textContent    = pageHits.length;

        renderSuggest(q, results, true);
        renderProducts(productHits, q);
        renderArticles(articleHits, q);
        renderPages(pageHits, q);

        saveRecent(q);
        kbResetIndex();
      }, 80);
    }

    function matches(item, q) {
      const haystack = [
        item.name || item.title || '',
        item.desc || '',
        ...(item.keywords || [])
      ].join(' ').toLowerCase();
      return q.toLowerCase().split(/\s+/).every(token => haystack.includes(token));
    }

    // ===== RENDER PRODUCTS =====
    function renderProducts(items, q) {
      const list = document.querySelector('[data-sd-results-products]');
      list.innerHTML = items.slice(0, 6).map((p, idx) => {
        const tone = SD_TONES[p.handle] || ['#fbe1e8', '#fdf3f5'];
        return `
          <a class="sd-product" href="${escapeHtml(p.url)}" data-sd-result data-handle="${escapeHtml(p.handle)}">
            ${idx === 0 && items.length > 1 ? '<span class="sd-best-match">Best match</span>' : ''}
            <span class="sd-product-image" style="--bgc1:${tone[0]};--bgc2:${tone[1]};"></span>
            <div class="sd-product-body">
              <h4 class="sd-product-name">${highlightTerms(p.name, q)}</h4>
              <p class="sd-product-desc">${highlightTerms(p.desc, q)}</p>
            </div>
            <div class="sd-product-action">
              <span class="sd-product-price">&euro;${escapeHtml(p.price)}</span>
              <button class="sd-product-quickadd" type="button"
                      data-sd-quickadd="${p.variantId}"
                      aria-label="${(FA.add_to_cart_aria || 'Add [name] to cart').replace('[name]', escapeHtml(p.name))}">
                <span data-sd-qa-label>+ ${QUICK_SHOP}</span>
              </button>
            </div>
          </a>`;
      }).join('');

      // Wire quick-add (results)
      list.querySelectorAll('[data-sd-quickadd]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          addToCart(btn.dataset.sdQuickadd, btn);
        });
      });

      const viewAll = document.querySelector('[data-sd-viewall-products]');
      if (items.length > 6) {
        viewAll.style.display = '';
        viewAll.textContent = `View all ${items.length} products →`;
        viewAll.href = `${window.Shopify && window.Shopify.routes ? '' : ''}/collections/all?q=${encodeURIComponent(currentQuery)}`;
      } else {
        viewAll.style.display = 'none';
      }
    }

    // ===== RENDER ARTICLES =====
    function renderArticles(items, q) {
      const list = document.querySelector('[data-sd-results-articles]');
      list.innerHTML = items.slice(0, 5).map(a => `
        <a class="sd-article" href="${escapeHtml(a.url)}" data-sd-result>
          <span class="sd-article-image"></span>
          <div class="sd-article-body">
            <h4 class="sd-article-title">${highlightTerms(a.title, q)}</h4>
            <p class="sd-article-meta">${escapeHtml(a.meta)}</p>
          </div>
        </a>`).join('');

      const viewAll = document.querySelector('[data-sd-viewall-articles]');
      if (items.length > 5) {
        viewAll.style.display = '';
        viewAll.textContent = `View all ${items.length} articles →`;
        viewAll.href = `/blogs/journal?q=${encodeURIComponent(currentQuery)}`;
      } else {
        viewAll.style.display = 'none';
      }
    }

    // ===== RENDER PAGES =====
    function renderPages(items, q) {
      const list = document.querySelector('[data-sd-results-pages]');
      list.innerHTML = items.map(pg => `
        <a class="sd-page" href="${escapeHtml(pg.url)}" data-sd-result>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
          </svg>
          <span class="sd-page-title">${highlightTerms(pg.title, q)}</span>
        </a>`).join('');
    }

    // ===== HIGHLIGHT =====
    function highlightTerms(text, q) {
      if (!q || !text) return escapeHtml(text);
      const tokens = q.toLowerCase().split(/\s+/).filter(t => t.length > 1);
      if (!tokens.length) return escapeHtml(text);
      let result = escapeHtml(text);
      tokens.forEach(token => {
        const re = new RegExp(`(${token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
        result = result.replace(re, '<span class="sd-highlight">$1</span>');
      });
      return result;
    }

    function escapeHtml(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }

    // ===== DID YOU MEAN (Levenshtein) =====
    function renderSuggest(q, anchorEl, onlyIfTypo) {
      const suggestion = suggestDidYouMean(q);
      if (!suggestion) return;
      if (onlyIfTypo && suggestion.toLowerCase() === q.toLowerCase()) return;
      suggestEl.style.display = '';
      var ddmBtn = `<button data-sd-suggest-click="${escapeHtml(suggestion)}"><strong>${escapeHtml(suggestion)}</strong></button>`;
      suggestEl.innerHTML = (FA.did_you_mean || 'Did you mean {suggestion}?').replace('{suggestion}', ddmBtn);
      anchorEl.parentNode.insertBefore(suggestEl, anchorEl);
      suggestEl.querySelector('button').addEventListener('click', (e) => {
        const sq = e.currentTarget.dataset.sdSuggestClick;
        input.value = sq;
        clearBtn.setAttribute('data-show', 'true');
        doSearch(sq);
      });
    }

    function suggestDidYouMean(q) {
      const ql = q.toLowerCase().trim();
      if (ql.length < 3) return null;
      const dict = new Set();
      PRODUCTS.forEach(p => {
        dict.add(p.name.toLowerCase());
        (p.keywords || []).forEach(k => dict.add(k.toLowerCase()));
      });
      ARTICLES.forEach(a => (a.keywords || []).forEach(k => dict.add(k.toLowerCase())));
      let best = null, bestDist = Infinity;
      dict.forEach(term => {
        if (term === ql) return;
        const dist = levenshtein(ql, term);
        if (term.length >= 4 && dist > 0 && dist <= 2 && dist < bestDist) {
          bestDist = dist; best = term;
        }
      });
      return best;
    }

    function levenshtein(a, b) {
      if (a === b) return 0;
      if (!a.length) return b.length;
      if (!b.length) return a.length;
      const m = [];
      for (let i = 0; i <= b.length; i++) m[i] = [i];
      for (let j = 0; j <= a.length; j++) m[0][j] = j;
      for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
          m[i][j] = b[i - 1] === a[j - 1]
            ? m[i - 1][j - 1]
            : Math.min(m[i - 1][j - 1] + 1, m[i][j - 1] + 1, m[i - 1][j] + 1);
        }
      }
      return m[b.length][a.length];
    }

    // ===== QUICK ADD TO CART (real fetch) =====
    async function addToCart(variantId, btn) {
      btn.disabled = true;
      try {
        const resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (resp.ok) {
          btn.setAttribute('data-added', 'true');
          btn.innerHTML = '<span>✓ ' + (FA.added || 'Added') + '</span>';

          // Refresh cart badge
          try {
            const cartResp = await fetch('/cart.js');
            if (cartResp.ok) {
              const cart = await cartResp.json();
              document.querySelectorAll('[data-cart-count]').forEach(el => {
                el.textContent = cart.item_count;
                el.classList.toggle('feel-header__cart-badge--hidden', cart.item_count === 0);
              });
            }
          } catch (_) {}

          // Open cart drawer (exposed by feel-cart-drawer.js)
          if (window.cartDrawer && typeof window.cartDrawer.open === 'function') {
            setTimeout(() => window.cartDrawer.open(), 200);
          }
        } else {
          btn.innerHTML = '<span>' + (FA.try_again || 'Try again') + '</span>';
        }
      } catch (err) {
        console.warn('[feel-search] addToCart error:', err);
        btn.innerHTML = '<span>' + (FA.error || 'Error') + '</span>';
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.removeAttribute('data-added');
        btn.innerHTML = '<span data-sd-qa-label>+ ' + QUICK_SHOP + '</span>';
      }, 2500);
    }

    // Wire static trending quick-add buttons (rendered in Liquid, have variantId)
    document.querySelectorAll('[data-sd-pre] [data-sd-quickadd]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        addToCart(btn.dataset.sdQuickadd, btn);
      });
    });

    // ===== RECENT SEARCHES =====
    const RECENT_KEY = 'feelawsm_recent_searches';
    const RECENT_MAX = 5;

    function getRecent() {
      try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; }
    }

    function saveRecent(q) {
      if (q.length < 2) return;
      let list = getRecent().filter(x => x.toLowerCase() !== q.toLowerCase());
      list.unshift(q);
      list = list.slice(0, RECENT_MAX);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (_) {}
    }

    function removeRecent(q) {
      const list = getRecent().filter(x => x !== q);
      try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (_) {}
      renderRecent();
    }

    function clearAllRecent() {
      try { localStorage.removeItem(RECENT_KEY); } catch (_) {}
      renderRecent();
    }

    function renderRecent() {
      const list = getRecent();
      if (!list.length) { recentSection.style.display = 'none'; return; }
      recentSection.style.display = '';
      recentList.innerHTML = list.map(q => `
        <div class="sd-recent-row" data-sd-recent-item="${q.replace(/"/g, '&quot;')}">
          <span class="sd-recent-left">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            ${escapeHtml(q)}
          </span>
          <button class="sd-recent-remove" data-sd-recent-remove="${q.replace(/"/g, '&quot;')}" aria-label="${(FA.remove_recent_aria || 'Remove [name]').replace('[name]', escapeHtml(q))}">&#215;</button>
        </div>`).join('');

      recentList.querySelectorAll('[data-sd-recent-item]').forEach(row => {
        row.addEventListener('click', (e) => {
          if (e.target.closest('[data-sd-recent-remove]')) return;
          const q = row.dataset.sdRecentItem;
          input.value = q;
          clearBtn.setAttribute('data-show', 'true');
          doSearch(q);
        });
      });

      recentList.querySelectorAll('[data-sd-recent-remove]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          removeRecent(btn.dataset.sdRecentRemove);
        });
      });
    }

    recentClear.addEventListener('click', clearAllRecent);

    // ===== KEYBOARD NAVIGATION =====
    let kbIndex = -1;

    function kbGetResults() {
      const panel = document.querySelector('[data-sd-panel][data-active="true"]');
      return panel ? Array.from(panel.querySelectorAll('[data-sd-result]')) : [];
    }

    function kbResetIndex() {
      kbIndex = -1;
      document.querySelectorAll('[data-kb-active]').forEach(el => el.removeAttribute('data-kb-active'));
    }

    function kbHighlight(index) {
      const items = kbGetResults();
      if (!items.length) return;
      document.querySelectorAll('[data-kb-active]').forEach(el => el.removeAttribute('data-kb-active'));
      if (index < 0) index = items.length - 1;
      if (index >= items.length) index = 0;
      kbIndex = index;
      items[kbIndex].setAttribute('data-kb-active', 'true');
      items[kbIndex].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    input.addEventListener('keydown', (e) => {
      const items = kbGetResults();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (items.length) kbHighlight(kbIndex + 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (items.length) kbHighlight(kbIndex - 1);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        if (kbIndex >= 0 && items[kbIndex]) items[kbIndex].click();
        else if (items.length > 0) items[0].click();
      } else if (e.key === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        const idx = Array.from(tabs).findIndex(t => t.getAttribute('data-active') === 'true');
        tabs[(idx + 1) % tabs.length].click();
      } else if (e.key === 'Tab' && e.shiftKey) {
        e.preventDefault();
        const idx = Array.from(tabs).findIndex(t => t.getAttribute('data-active') === 'true');
        tabs[(idx - 1 + tabs.length) % tabs.length].click();
      }
    });

    // ===== CMD+K / CTRL+K GLOBAL SHORTCUT =====
    document.addEventListener('keydown', (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        drawer.getAttribute('data-open') === 'true' ? closeDrawer() : openDrawer();
      }
    });

    // Shortcut hint: ⌘K on Mac, Ctrl K elsewhere
    if (shortcutHint) {
      const isMac = /Mac|iPhone|iPad/i.test(navigator.platform);
      if (!isMac) shortcutHint.innerHTML = '<kbd>Ctrl</kbd><kbd>K</kbd>';
    }
  }

})();
